import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ApplicationMenu from './ApplicationMenu';
import * as actions from './actions';
import { fetchCredentials } from '../credentials/actions';

class ApplicationMenuContainer extends React.Component {
	render() {
		const {
			location,
			collapsed,
			productName,
			productRelease,
			productVersion,
			notifications
		} = this.props;

		return (
			<ApplicationMenu
				navKey={window.$conf.prefix}
				location={location}
				productName={productName}
				productRelease={productRelease}
				productVersion={productVersion}
				collapsed={collapsed}
				onToggle={this.props.actions.toggleNavCollapsed}
				notifications={notifications}
			/>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		productName: state.system.config ? state.system.config.productName : '',
		productRelease: state.system.config ? state.system.config.productRelease : '',
		productVersion: state.system.config ? state.system.config.productVersion : '',
		location: (state && state.location && state.location.location) || ownProps.location,
		collapsed: (state && state.navigation.collapsed),
		notifications: (state && state.navigation.notifications)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
		fetchCredentials: bindActionCreators(fetchCredentials, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ApplicationMenuContainer);
